export enum vehicleTypesConstants {
  GET_VEHICLE_TYPES = 'GET_VEHICLE_TYPES',
  GET_VEHICLE_TYPE = 'GET_VEHICLE_TYPE',
  ADD_VEHICLE_TYPE = 'ADD_VEHICLE_TYPE',
  EDIT_VEHICLE_TYPE = 'EDIT_VEHICLE_TYPE',
  DELETE_VEHICLE_TYPE = 'DELETE_VEHICLE_TYPE',
}
